/* prettier-ignore */

export default [
    {
        path: '/',
        redirect: '/login',
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import(/* webpackChunkName: "login" */ '../views/Login/index.vue'),
    },
    {
        path: '/iframe',
        name: 'Iframe',
        component: () => import(/* webpackChunkName: "iframe" */ '../views/Iframe/index.vue'),
    },
    // webview 专门的三方登录页面
    {
        path: '/login/webview/:key',
        name: 'webviewLogin',
        component: () => import(/* webpackChunkName: "webviewLogin" */ '../views/OAuthWebview/index.vue'),
    },
    // 三方返回的 redirect_uri
    {
        path: '/login/oauth/:key', // key 为当前授权的三方
        name: 'oauthLogin',
        // prettier-ignore
        component: () => import(/* webpackChunkName: "oauthLogin" */ '../views/OAuthLogin/index.vue'),
    },
    {
        path: '/captcha',
        name: 'Captcha',
        component: () => import(/* webpackChunkName: "captcha" */ '../views/Captcha/index.vue'),
    },
    // 给 WebView 查看协议用的 o(*≧д≦)o!!
    {
        path: '/procotol', // 这个单词拼错了，将错就错，不要改 (｡ŏ_ŏ)
        name: 'Protocol',
        component: () => import(/* webpackChunkName: "protocol" */ '../views/Protocol/index.vue'),
    },
    // 获取 webTicket
    {
        path: '/webticket',
        name: 'Webticket',
        component: () => import(/* webpackChunkName: "webticket" */ '../views/WebTicket/index.vue'),
    },
    // 登出
    {
        path: '/logout',
        name: 'Logout',
        component: () => import(/* webpackChunkName: "logout" */ '../views/Logout/index.vue'),
    },
    // 龙之谷账号迁移相关页面
    {
        path: '/transfer',
        component: () => import(/* webpackChunkName: "transferWrapper" */ '../views/Transfer/index.vue'),
        children: [
            // Tencent LI 账号登录页面
            {
                path: 'tencent/:region', // region 为地区码，tw/ko/ja/global
                name: 'tencentLiPass',
                component: () => import(/* webpackChunkName: "transferTencent" */ '../views/Transfer/components/TencentLiPass.vue'),
            },
            // 盛趣迁移账号登录页面
            {
                path: 'login',
                name: 'transferLogin',
                component: () => import(/* webpackChunkName: "transferLogin" */ '../views/Transfer/components/TransferLogin.vue'),
            },
            // 迁移结果页面
            {
                path: 'result',
                name: 'transferResult',
                component: () => import(/* webpackChunkName: "transferResult" */ '../views/Transfer/components/TransferResult.vue'),
            },
        ],
    },
    {
        path: '/revoke',
        name: 'Revoke',
        component: () => import(/* webpackChunkName: "revoke" */ '../views/Revoke/index.vue'),
    },
    {
        path: '*',
        redirect: '/login',
    },
];
